var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"foryou"},[_c('div',{staticClass:"left"},[_vm._v(" 为您提供咨询，制定投放方案 "),_c('br'),_vm._v(" 为您监测效果，优化曝光效果 ")]),_c('div',{staticClass:"right"},[_vm._v(" 让您的广告以低成本，高效率的方式登上各大主流页面。 "),_c('br'),_vm._v(" 您与最前沿的营销方式仅一步之遥，我们帮您用科技铸就品牌，用专业 "),_c('br'),_vm._v(" 产生效益 ")])])
}]

export { render, staticRenderFns }